export default "__VITE_ASSET__CtgVNAwZ__"